import {StoreType} from '..';

export const donationsData = (state: StoreType) => state.userDonationStore.donations;
export const totalDonationsAmount = (state: StoreType) => state.userDonationStore.totalDonationsAmount;
export const donationsLoader = (state: StoreType) => state.userDonationStore.isLoading;
